// TODO: this is not ideal and I would like a more programmatic approach to this.
// Each fill color (key) has a corresponding stroke color (value).
const variationStrokeColorPalette = {
  '#34B6D0': '#1D6C7C',
  '#EEC340': '#8D6D0C',
  '#38D9A9': '#188161',
  '#228BE6': '#0F518A',
  '#A34FDE': '#551881',
  '#00B969': '#009957',
  '#FF386B': '#990026',
  '#282828': '#4D4D4D',
  '#40E39C': '#148554',
  '#CAA636': '#796320',
  '#7A3BA7': '#532871',
  '#3DD6F5': '#087A91',
  '#D9305B': '#811832',
  '#BCBEC0': '#4A4D4F',
} as const;

/**
 * Returns the stroke color for a variation fill color.
 * If the fill color isn't in the palette, returns undefined.
 */
export function getVariationStrokeColor(fillColor: string): string | undefined {
  return variationStrokeColorPalette[fillColor as keyof typeof variationStrokeColorPalette] || undefined;
}
